(function (angular) {
    'use strict';

    angular.module('app')
        .controller('pickFeaturedMemberController', pickFeaturedMemberController);

    pickFeaturedMemberController.$inject = [
        '$uibModalInstance',
        'UsersApi'
    ];

    function pickFeaturedMemberController(
        $uibModalInstance,
        UsersApi
    ) {
        var vm = this;

        // properties
        vm.isLoading = false;
        vm.users = {};
        vm.filters = {
            role: 'member',
            is_active: 1,
            full_name: '',
            page: 1
        };

        // methods
        vm.dismiss = $uibModalInstance.dismiss;
        vm.getUsers = getUsers;
        vm.pickUser = pickUser;

        /**
         * Retrieves users from the API
         * @return {void}
         */
        function getUsers() {
            vm.isLoading = true;
            UsersApi.get(vm.filters, function handleUsersResponse(response) {
                vm.users = response;
                vm.isLoading = false;
            }, function handleUsersError() {
                vm.isLoading = false;
            });
        }

        /**
         * Returns the chosen user to parent controller
         * @param  {object} user - API user object
         * @return {void}
         */
        function pickUser(user) {
            $uibModalInstance.close(user);
        }

        getUsers();
    }

}(angular));
